import React from "react";

import defaultStyles from "@stadium/ui/src/components/HeaderContent/main.module.scss";

const HeaderContent = ({
  list = [],
  banner = null,
  renderLink,
  styles = defaultStyles,
  gridView = false,
}) => {
  const containerClass =
    list.length > 1 ? styles.headerContentMultipleList : styles.headerContentSingleList;

  const getGridStyle = (items) => {
    const columns = Math.ceil(items / 5);
    return { gridTemplateColumns: `repeat(${columns}, 1fr)` };
  };

  return (
    <>
      <div className={styles.headerContentRow}>
        {list.map((data) => {
          const {
            title,
            items,
            className = "",
            applyDividerClass = false,
            showDividerLine = false,
          } = data;
          return (
            <>
              <div
                className={`${containerClass} ${className} ${
                  applyDividerClass && styles.fullBlockLinks
                }`}
                key={title}
              >
                <div
                  className={`${styles.headerContentContainer} ${
                    gridView ? styles.gridDropdowns : ""
                  }`}
                  style={gridView ? getGridStyle(items.length) : {}}
                >
                  {title && (
                    <div className={styles.headerContentTitleContainer}>
                      <div className={styles.headerContentTitle}>
                        <span>{title}</span>
                      </div>
                    </div>
                  )}
                  {items.map(renderLink)}
                </div>
              </div>
              {showDividerLine && <div className={styles.dividerLine}></div>}
            </>
          );
        })}
        {banner && (
          <div className={styles.headerContentColRight}>
            <div className={styles.responsiveBannerWidth}>{banner}</div>
          </div>
        )}
      </div>
    </>
  );
};

export default HeaderContent;
